import React, { Component } from 'react';
import BaseLayout from './../../templates/base'
import RoleEditForm from './../../elements/roles/form';
import Loading from "../../elements/loading";
import RolesAdd from './../../elements/roles/widget/roles_add';

class RoleEdit extends Component {
	render() {
		const { roles, permissions } = this.props;
		return (
			roles.isFetching || permissions.isFetching ? <Loading/>:<RoleEditForm {...this.props} />
		)
	}

	componentWillMount() {
		this.props.resetRolesList();
		this.props.fetchPermissions();
	}
}

//export default BaseLayout(RoleEdit, {title: `Crear Perfil`, subnav: {icon: 'fa-user-secret', name: 'Administración', actions: {url: '/perfiles/crear', name: 'Agregar perfil'}}});
export default BaseLayout(RoleEdit, {
	title: `Crear perfil`,
	subnav: {
		icon: 'fa-user-secret',
		name: 'Administración',
		actions: [
			{
				type: 'element',
				url: null,
				name: 'Agregar',
				element: <RolesAdd />
			}
		]
	}
});


// WEBPACK FOOTER //
// ./src/layouts/roles/create.jsx